var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasData
    ? _c(
        "div",
        { class: _vm.containerClass },
        [
          _c(
            "Processing",
            {
              attrs: {
                processing: _vm.loading,
                backgroundOpacity: 25,
                spinner: "",
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "h-full flex justify-center flex-col items-center",
          class: _vm.spinnerCenteredStyles,
        },
        [
          _vm.loading ? _c("Spinner") : _vm._e(),
          _vm.showNoInformation
            ? _c("h3", { staticClass: "leading-7 text-xl" }, [
                _vm._v(" " + _vm._s(_vm.customPlaceholderMessage) + " "),
              ])
            : _vm._e(),
          _vm._t("empty_placeholder"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }